/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Draft_Review_CtaInputs */

const en_directory_submit_enrich_draft_review_cta = /** @type {(inputs: Directory_Submit_Enrich_Draft_Review_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a plan`)
};

const zh_directory_submit_enrich_draft_review_cta = /** @type {(inputs: Directory_Submit_Enrich_Draft_Review_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择方案`)
};

/**
* | output |
* | --- |
* | "Choose a plan" |
*
* @param {Directory_Submit_Enrich_Draft_Review_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_draft_review_cta = /** @type {((inputs?: Directory_Submit_Enrich_Draft_Review_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Draft_Review_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_draft_review_cta(inputs)
	return zh_directory_submit_enrich_draft_review_cta(inputs)
});
export { directory_submit_enrich_draft_review_cta as "directory.submit.enrich.draft_review_cta" }